<template>
  <div>
  <div class="triangulo"></div>
  <div class="contenidoTriangulo" id="tresPasos">
      <Titulo titulo="En tres pasos estás protegido:" />
      <div class="row m-0 justify-content-center">
        <div class="col-lg-8 pt-5">
          <div class="row pt-5">
            <div class="col-lg-6" data-aos="fade-up" data-aos-duration="1000">
                <Trespasos numero="1" texto="Cuéntanos tus necesidades" :imagen="img1" />
            </div>
            <div class="col-lg-6 p-5 text-lg-left text-center" data-aos="fade-up" data-aos-duration="1000">
                <img src="@/assets/images/nuestros-servicios_flecha01.png" class="flecha" />
            </div>
            <div class="col-lg-6" data-aos="fade-up" data-aos-duration="1000">
            </div>
            <div class="col-lg-6" data-aos="fade-up" data-aos-duration="1000">
                <Trespasos numero="2" texto="Definamos el plan perfecto" :imagen="img2" />
            </div>
            <div class="col-lg-6 p-5 text-lg-left text-center order-lg-12" data-aos="fade-up" data-aos-duration="1000">
                <img src="@/assets/images/nuestros-servicios_flecha02.png" class="flecha" />
            </div>
            <div class="col-lg-6 order-lg-1" data-aos="fade-up" data-aos-duration="1000">
                <Trespasos numero="3" texto="Y contrátalo en unos minutos." :imagen="img3" />
            </div>
          </div>
        </div>
      </div>
  </div>
  </div>
</template>

<script>
import Img1 from '@/assets/images/nuestros-servicios_3-pasos-01pajarillo.svg'
import Img2 from '@/assets/images/nuestros-servicios_3-pasos-02plan.svg'
import Img3 from '@/assets/images/nuestros-servicios_3-pasos-03contrato..svg'
import Titulo from '@/components/Titulo.vue'
import Trespasos from '@/components/Trespasos.vue'
export default {
  name: 'Trespasoscompleto',
  data() {
      return {
          img1: Img1,
          img2: Img2,
          img3: Img3,
      }
  },
  components: {
      Titulo,
      Trespasos,
  },
  props: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
img.flecha {
    width: 55px;
}
.triangulo {
    margin-top: 150px;
    width: 100%;
    height: 100px;
    clip-path: polygon(50% 0, 0 100%, 100% 100%);
    background: #E6E7F4;
}
.contenidoTriangulo {
    background: #E6E7F4;
    padding: 1px 0 190px 0;
}
@media only screen and (max-width: 990px){
.triangulo {
    height: 50px;
}
}
</style>
